// import React from "react";
// import "./InfoSection.css";

// const InfoSection = ({ data }) => {
//   if (!data) return null;

//   return (
//     <section className="branding-section">
//       {/* Logos */}
//       {data.logos && data.logos.length > 0 && (
//         <div className="branding-logos">
//           {data.logos.map((logo, idx) => (
//             <img
//               key={idx}
//               src={logo}
//               alt={`Brand ${idx}`}
//               className="brand-logo"
//             />
//           ))}
//         </div>
//       )}

//       {/* Main Content */}
//       <div className="branding-content">
//         {/* Left: Quote */}
//         <div className="branding-left">
//           {data.shortQuote && (
//             <p className="branding-quote animate-fade-in-left">
//               {data.shortQuote}
//             </p>
//           )}
//         </div>

//         {/* Right: Vertical line + text */}
//         <div className="branding-right-wrapper">
//           <div className="branding-line"></div>
//           <div className="branding-right animate-fade-in-up">
//             <button className="branding-btn">{data.service.servicename}</button>
//             <p className="branding-description">{data.service.Description}</p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default InfoSection;

import React from "react";
import "./InfoSection.css";

const InfoSection = ({ data }) => {
  if (!data) return null;

  return (
    <section className="branding-section">
      {/* Logos */}
      {data.logos && data.logos.length > 0 && (
        <div className="branding-logos">
          {data.logos.map((logo, idx) => (
            <img
              key={idx}
              src={logo}
              alt={`Brand ${idx}`}
              className="brand-logo"
            />
          ))}
        </div>
      )}

      {/* Main Content */}
      <div className="branding-content">
        {/* Left: Quote */}
        <div className="branding-left">
          {data.shortQuote && (
            <p className="branding-quote animate-fade-in-left">
              {data.shortQuote}
            </p>
          )}
        </div>

        {/* Right: Vertical line + text */}
        <div className="branding-right-wrapper">
          <div className="branding-line"></div>
          <div className="branding-right animate-fade-in-up">
            <button className="branding-btn">{data.servicename}</button>
            <p className="branding-description">{data.Description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
